export default __webpack_public_path__ + "static/media/live.d6e5ca3d.svg";